import * as React from 'react';
import { Input, Success16 } from '@cian/ui-kit';
import * as styles from './CadastralNumberInput.css';
import { ICadastralNumberInputProps } from '../../types';
import classNames from 'classnames';

export const CadastralNumberInput: React.FC<ICadastralNumberInputProps> = ({
  value,
  onChange,
  invalid,
  checked,
  loading,
  required,
}) => {
  return (
    <div className={classNames(required && styles['required'])}>
      <Input
        placeholder="00:00:0000000:000"
        width={204}
        value={value}
        onChange={onChange}
        maxLength={30}
        size="XS"
        invalid={invalid}
        rightAdornment={
          checked && (
            <div className={styles['success-icon']}>
              <Success16 color="success_100" />
            </div>
          )
        }
        loading={loading}
      />
    </div>
  );
};
